import { Request } from '@/classes/Request.ts'
import { Util } from '@/modules/util'

export const setContractRevisionAutoPay = async (payload: Object): Promise<any> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post(`/ajax/auto_pay/set_contract_revision_auto_pay`, payload)
      .then(result => {
        resolve(Util.Obj.keysToCamel(result.data))
      })
      .catch(err => {
        reject(err.responseText)
      })
  })
}
